import {Injectable} from '@angular/core';
import {of, Subscription, timer} from 'rxjs';
import {environment} from '@environments/environment';
import moment from 'moment';
import {catchError, take} from 'rxjs/operators';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private bypassClient: HttpClient;
    private timerSubscription: Subscription;
    // Temporarily disabled in favor of the configurable idle/logout flow in PagesComponent.
    // private lastActivityTime = Date.now();
    // private inactivityTimeoutId: ReturnType<typeof setTimeout>;
    // private activityListener: () => void;

    constructor(
        private handler: HttpBackend,
        private router: Router,
    ) {
        this.bypassClient = new HttpClient(handler);
        if (location.href.includes('live-lineage') || location.href.includes('reset-password') || location.href.includes('signup') || location.href.includes('login')) {
            return;
        }
        const tokenExpired = this.isAccessTokenExpire();
        if (tokenExpired) {
            this.requestAccessToken();
        }
    }

    public hasSessionTokens(): boolean {
        return !!localStorage.getItem('accessToken') && !!localStorage.getItem('refreshToken');
    }

    startTokenTimer() {
        // Hard-coded 15 minute inactivity logout is intentionally disabled for now.
        // The configurable idle/logout flow in PagesComponent should be the only active mechanism.
        //
        // this.activityListener = () => {
        //     this.lastActivityTime = Date.now();
        //     this.scheduleInactivityTimeout();
        // };
        // this.document.addEventListener('mousemove', this.activityListener, {passive: true});
        // this.document.addEventListener('click', this.activityListener, {passive: true});
        // this.document.addEventListener('keydown', this.activityListener, {passive: true});
        // this.document.addEventListener('touchstart', this.activityListener, {passive: true});
        //
        // this.scheduleInactivityTimeout();

        this.timerSubscription = timer(0, environment.accessTokenCheckup)
            .subscribe(() => {
                const tokenExpired = this.isAccessTokenExpire();
                const tokenLess = window.location.href.includes('live-lineage');
                if (tokenExpired && !tokenLess) {
                    this.requestAccessToken();
                }
            });
    }

    stopTokenTime() {
        this.timerSubscription?.unsubscribe();
        // clearTimeout(this.inactivityTimeoutId);
        // if (this.activityListener) {
        //     this.document.removeEventListener('mousemove', this.activityListener);
        //     this.document.removeEventListener('click', this.activityListener);
        //     this.document.removeEventListener('keydown', this.activityListener);
        //     this.document.removeEventListener('touchstart', this.activityListener);
        //     this.activityListener = null;
        // }
    }

    validateToken(email, token) {
        return this.bypassClient
            .post(`${environment.apiUrl}userAccount/ValidateOTT`, {email}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
    }

    public isAccessTokenExpire() {
        if (!this.hasSessionTokens()) {
            return true;
        }

        const accessTokenExpiration = localStorage.getItem('accessTokenExpiration');
        if (accessTokenExpiration) {
            const b = moment.utc(accessTokenExpiration);
            const a = moment.utc();
            const diff = b.diff(a, 'minutes');
            return diff < environment.accessTokenExpirationHeadUp;
        }
        return true;
    }

    // private scheduleInactivityTimeout() {
    //     clearTimeout(this.inactivityTimeoutId);
    //     this.inactivityTimeoutId = setTimeout(() => this.handleInactivityTimeout(), INACTIVITY_TIMEOUT_MS);
    // }
    //
    // private handleInactivityTimeout() {
    //     this.stopTokenTime();
    //     localStorage.removeItem('accessToken');
    //     localStorage.removeItem('refreshToken');
    //     localStorage.removeItem('accessTokenExpiration');
    //     localStorage.removeItem('refreshTokenExpiration');
    //     this.router.navigate(['login']);
    // }

    private requestAccessToken(request?) {
        if (!this.hasSessionTokens()) {
            this.clearSessionState();
            this.router.navigate(['login']);
            return;
        }

        const refreshToken = localStorage.getItem('refreshToken');
        if (!!refreshToken) {
            this.bypassClient.post(`${environment.apiUrl}userAccount/refresh`, {RefreshToken: refreshToken})
                .pipe(
                    take(1),
                    catchError(err => {
                        if ([403].includes(err.status)) {
                            this.clearSessionState();
                            setTimeout(() => {
                                this.router.navigate(['login']);
                            }, 1000);
                        }

                        return of();
                    }),
                )
                .subscribe((accessData: any) => {
                    if (accessData.accessToken == null || accessData.accessToken == 'null') {
                        this.clearSessionState();
                        this.router.navigate(['login']);
                        return;
                    }
                    localStorage.setItem('accessToken', accessData.accessToken);
                    localStorage.setItem('accessTokenExpiration', accessData.expiration);
                    localStorage.setItem('refreshToken', accessData?.refreshToken.token);
                    localStorage.setItem('refreshTokenExpiration', accessData?.refreshToken.expiration);
                });
        } else {
            this.clearSessionState();
            this.router.navigate(['login']);
        }
    }

    private clearSessionState() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('accessTokenExpiration');
        localStorage.removeItem('refreshTokenExpiration');
    }
}
